import React from 'react';
import './ProductGrid.css';
import '../styles/animations.css';
import { useScrollAnimation, useStaggeredAnimation } from '../hooks/useScrollAnimation';

const ProductGrid = () => {
  const [sectionRef, isSectionVisible] = useScrollAnimation();
  const [setDairyVisible, visibleDairyItems] = useStaggeredAnimation(7, 0.2);

  React.useEffect(() => {
    if (isSectionVisible) {
      // Start dairy products animation immediately
      setDairyVisible(true);
    }
  }, [isSectionVisible, setDairyVisible]);

  // ⭐ NEW: WhatsApp Order Handler
  const handleWhatsAppOrder = (productName) => {
    const phone = "917230920774";
    const message = `Hello, I want to order ${productName}.`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  const dairyProducts = [
    {
      id: 1,
      name: "RAW A2 COW MILK",
      image: "/images/mr/jfam_a2_cow_milk.png",
      description: "Premium A2 cow milk from Sahiwal cows, easy to digest and naturally pure"
    },
    {
      id: 2,
      name: "RAW BUFFALO MILK",
      image: "/images/mr/jfam_buffalo_milk.png",
      description: "Creamy buffalo milk, rich and wholesome for a healthy diet"
    },
    {
      id: 3,
      name: "RAW COW MILK",
      image: "/images/mr/jfam_cow_milk.png",
      description: "Pure cow's milk, fresh from the farm to your home"
    },
    {
      id: 5,
      name: "BUFFALO CHAACH",
      image: "/images/mr/jfam_buffalo_chaach.png",
      description: "Traditional buffalo buttermilk, refreshing and nutritious"
    },
    {
      id: 7,
      name: "COW CHAACH",
      image: "/images/mr/jfam_cow_chaach.png",
      description: "Fresh cow buttermilk, cooling and digestive"
    },
    {
      id: 8,
      name: "DAHI",
      image: "/images/mr/jfam_dahi.png",
      description: "Fresh homemade yogurt, probiotic-rich and creamy"
    },
    {
      id: 10,
      name: "PANEER",
      image: "/images/mr/jfam_paneer.png",
      description: "Fresh homemade paneer, soft and protein-rich"
    }
  ];

  return (
    <section ref={sectionRef} className="product-grid-section">
      <div className="container">
        {/* Section Heading */}
        <div className="section-heading">
          <h2 className="products-title">Our Products</h2>
        </div>

        {/* Dairy Products Row */}
        <div className="product-row dairy-row stagger">
          {dairyProducts.map((product, index) => (
            <div
              key={product.id}
              className={`product-card dairy-card img-card ${visibleDairyItems.includes(index) ? 'visible' : ''}`}
            >
              <div className="product-image-container">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                />
              </div>

              {/* ⭐ UPDATED BUY NOW BUTTON WITH WHATSAPP FUNCTION */}
              <button 
                className="btn btn-primary buy-now-btn"
                onClick={() => handleWhatsAppOrder(product.name)}
              >
                BUY NOW
              </button>

              <div className="product-name">{product.name}</div>
              <div className="product-description">{product.description}</div>
              <div className="product-contact">Call +91 72309 20774</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
